import { Button } from "@shopify/polaris";
import { useState } from "react";
import Order from "./Order";
import { NoOrderData } from "../components/Helpers";
import { useOrderId } from "../hooks/useOrderId";

export default function HomePage() {
  const orderId = useOrderId();

  // Check if SHOW_DEBUG_INFO is set to true
  // Input: nested JSON string containing true
  // This is a function to prevent optimization of the constant during build
  const showDebugInfo = () => {
    const showDebugInfoEnv = import.meta.env.SHOW_DEBUG_INFO;
    return showDebugInfoEnv == "true"; // note '==' instead of '==='
  }
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{ paddingBottom: 40 }}>
      {orderId ? (
        <Order orderId={orderId} />
      ) : (
        <NoOrderData title="Please, provide Order ID" />
      )}
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <div style={{ opacity: 0.7 }}>
          {showDebugInfo() ? (
            <Button
              plain
              size="slim"
              disclosure={expanded ? 'up' : 'down'}
              onClick={() => {
                setExpanded(!expanded);
              }}
            >
              v.{import.meta.env.BUILD_VERSION}
            </Button>
          ) : (
            `v.${import.meta.env.BUILD_VERSION}`
          )}
        </div>
        {expanded && (
          <div
            style={{
              fontSize: '12px',
              fontFamily: 'monospace',
              margin: '5px 40px',
            }}
          >
            <div
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'start',
              }}
            >
              <span>
                <b>EMAIL_PEARSOX:</b> {import.meta.env.EMAIL_PEARSOX}
              </span>
              <span>
                <b>EMAIL_MKSOCKS:</b> {import.meta.env.EMAIL_MKSOCKS}
              </span>
              <span>
                <b>EMAIL_UNIFORMS:</b> {import.meta.env.EMAIL_UNIFORMS}
              </span>
              <span>
                <b>EMAIL_CC:</b> {import.meta.env.EMAIL_CC}
              </span>
              <span>
                <b>EMAIL_BCC:</b> {import.meta.env.EMAIL_BCC}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}